import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentEn = () => {
    return (
        <HighlightedText
            text="CLAIM YOUR BONUS 325% Bonus + 400 FREE SPINS"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakAfterWords={['CLAIM']}
            breakBeforeWords={['325%', '+']}
            className={styles.text_content}
        />
    )
}
